import Navigo from 'navigo';
import { getRandomElement } from './utils';
import { bgColors } from './constants';

export class Router {
    constructor(){
        this.navigoRouter = false;
    }
    init() {
        let store = window.store;
        this.navigoRouter  = new Navigo('/');

        this.navigoRouter.on('*', (match) => {
          //console.log(match);
          //console.log(match.url);
          if(store.state.firstCallRouter){
            store.setFirstCallRouter(false);
          } else {
            if(match.url == ""){
              store.setSliderPostURIAction("/");
              document.body.classList.add("home");
            } else {
              document.body.classList.remove("home");
              //console.log(match.url.replace(/^\/?([^\/]+(?:\/[^\/]+)*)\/?$/, '/$1/'))
              store.setSliderPostURIAction(match.url.replace(/^\/?([^\/]+(?:\/[^\/]+)*)\/?$/, '/$1/'));
            }

            var mainRight = document.getElementById('main-right-container');
            mainRight.scrollTop = 0;

            let newBgColor = getRandomElement(bgColors, store.state.currentBgColor);
            document.documentElement.style.setProperty("--bg-color", newBgColor);
            store.setCurrentBgColor(newBgColor);
          }
        },
        {
          already(match) {
            document.getElementById('main-right-container').classList.remove('hide');
            document.getElementById('menu__wrapper').classList.remove('active');         
            let newBgColor = getRandomElement(bgColors, store.state.currentBgColor);
            document.documentElement.style.setProperty("--bg-color", newBgColor);
            store.setCurrentBgColor(newBgColor);
          }
        });
        this.navigoRouter.resolve();
    }
}